<template>
  <div class="smy__card-full-box page-org">
    <Card
      class="smy__card-full"
      :bordered="false"
      >
      <p slot="title">
        模板详情
      </p>
      <p slot="extra" class="extra">
      </p>
      <div class="options">
        <Button
          type="ghost"
          icon="ios-undo"
          @click="back"
        >返回</Button>
      </div>
      <div class="">
        <!-- 上方模板信息 -->
        <div class="top">
          <div class="top-img">
            <img :src="template.imgUrl" alt="">
          </div>
          <div class="top-info">
            <div class="top-info-item">
              模板名称
            </div>
            <div class="top-info-item">
              行业标签
            </div>
            <div class="top-info-item">
              上传者
            </div>
            <div class="top-info-item">
              详细描述
            </div>
          </div>
          <div class="top-info">
            <div class="top-info-value">
              {{template.name}}
            </div>
            <div class="top-info-value">
              {{template.industryName}}
            </div>
            <div class="top-info-value">
              {{template.enterpriseName}}
            </div>
            <div class="top-info-value">
              {{template.createtime}}
            </div>
          </div>
        </div>
        <!-- 工单字段和进度字段页签 -->
        <div class="field">
          <Tabs value="templateField">
            <TabPane label="工单字段" name="templateField">
              <TemplateField :id="id"/>
            </TabPane>
            <TabPane label="进度字段" name="processField" v-if="template.type === 1">
              <ProcessField :id="id"/>
            </TabPane>
          </Tabs>
        </div>
        <div class="examine" v-if="template.auditState === 0">
          <Button type="primary" class="examine-btn" @click="examine('审核通过', 1)">审核通过</Button>
          <Button type="ghost" class="examine-btn" @click="examine('审核驳回', 2)">审核驳回</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import TemplateField from './TemplateField'
import ProcessField from './ProcessField'

export default {
  components: {
    TemplateField,
    ProcessField
  },
  props: {
    id: {
      required: true
    }
  },
  data () {
    return {
      template: {}
    }
  },
  methods: {
    // 提交审核
    examine (name, auditState) {
      this.$Modal.confirm({
        title: '审核',
        content: `确认${name}吗？`,
        onOk: () => {
          this.$http.put('/templateExamine/examine', {
            id: this.id,
            auditState
          }).then(res => {
            if (res.success) {
              this.$Message.success('审核成功')
              this.template.auditState = auditState
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    back () {
      this.$router.back()
    }
  },
  created () {
    this.$http.get('/templateExamine', {
      params: {
        id: this.id
      }
    }).then(res => {
      if (res.success) {
        this.template = res.data
      } else {
        this.$Message.error(res.message)
      }
    })
  }
}
</script>

<style lang="less" scoped>
.options {
  margin-bottom: 10px;
}

.top {
  display: flex;
  height: 100px;

  .top-img {
    img {
      width: 100px;
      height: 100px;
    }
  }

  .top-info {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 12px;

    .top-info-item {
      color: #405060;
    }

    .top-info-value {
      margin-left: 10px;
      color: #80848F;
    }
  }
}

.examine {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;

  .examine-btn {
    margin-left: 10px;
  }
}

.field {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/templeManage/templeMarket/Detail.vue